import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteNotification } from "../../services/notification";
import { toast } from "react-toastify";
import { IIndicators } from "../../types";


const useDeleteNotification = (indicators: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteNotification,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["notifications"] });
                indicators.setIsProcessRunning(false);
                toast.success('Notifications deleted successfully')
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
};

export default useDeleteNotification;
